import { dateToServer } from 'helpers/formatters/date';
import { CalculationFrequency } from 'modules/BenchmarkForm';
import { BenchmarkTypes } from 'types/Benchmark';
import { divideWithHighPrecisionNumbers } from 'helpers/formatters/number';

const mapTimeWindow = (data: any) => {
  const timeWindow: any = {
    fromDate: dateToServer(new Date(data.fromDate)),
    lineItems: [],
  };
  for (const lineItem of data.lineItems) {
    const li: any = {};
    if (
      typeof lineItem.returnComponent === 'string' &&
      lineItem.returnComponent.includes('-')
    ) {
      li['returnComponentBenchmarkId'] = lineItem.returnComponent;
    } else {
      li['returnComponentResourceId'] = Number(lineItem.returnComponent);
    }
    li.weight = divideWithHighPrecisionNumbers(lineItem.weight, 100);
    timeWindow.lineItems.push(li);
  }

  return timeWindow;
};

const rebalanceFrequencyCustomId = 6;

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(originalValues: any, newValues: any) {
  const timeWindows = newValues.timeWindows
    ? newValues.timeWindows.map(mapTimeWindow)
    : [];

  const rebalanceFrequencyCustomMonths =
    rebalanceFrequencyCustomId !== newValues.rebalanceFrequencyId
      ? null
      : newValues.rebalanceFrequencyCustomMonths.reduce(
          (res: any, item: any) => ({ ...res, [item.value]: true }),
          {}
        );

  return {
    id: originalValues?.id,
    name: newValues.name,
    typeId: BenchmarkTypes.StaticWeighted,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    baseCurrencyCode: newValues.baseCurrencyCode,
    rebalanceFrequencyId:
      newValues.rebalanceFrequency?.typeId ?? newValues.rebalanceFrequencyId,
    rebalanceFrequencyCustomMonths:
      newValues.rebalanceFrequency?.customMonths ||
      rebalanceFrequencyCustomMonths,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
      newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    useDailyToMonthlyLinking: parseBoolean(newValues.useDailyToMonthlyLinking)
      ? true
      : false,
    description: newValues.description,
    customLagDate: newValues.customLagDate || null,
    timeWindows,
    pushTimeWindowsToPortfolioAnalytics: newValues.pushTimeWindowsToPortfolioAnalytics,
    lookThroughDepth: newValues.lookThroughDepth
  };
}
